const findDatasetCollectionEntities = ({ entities }, identifier, attribute = 'code') => (
  entities.find((e) => e[attribute] === identifier)
);

export default findDatasetCollectionEntities;
